if (!customElements.get('sweepstakes-prizes')) {
  customElements.define(
    'sweepstakes-prizes',
    class SweepstakesPrizes extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector('.sweepstakes-prizes__carousel');
        this.wrapper = this.querySelector('.swiper-wrapper');
        this.emptyText = this.dataset.emptyText || 'No current prizes';

        if (!this.swiperEl || !this.wrapper) return;

        this.orderSlides();
        this.startBadgeUpdates();
        this.initSlider();
      }

      disconnectedCallback() {
        if (this.countdownInterval) clearInterval(this.countdownInterval);
        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy();
        }
      }

      parseDate(value) {
        if (!value) return null;
        const parsed = Date.parse(value);
        return Number.isNaN(parsed) ? null : parsed;
      }

      orderSlides() {
        const now = Date.now();
        const slides = Array.from(this.wrapper.querySelectorAll('.sweepstakes-prizes__slide'));

        const decorated = slides.map((slide) => {
          const start = this.parseDate(slide.dataset.startDate);
          const end = this.parseDate(slide.dataset.endDate);
          let state = 'undated';
          if (start !== null && end !== null) {
            if (now >= start && now <= end) state = 'active';
            else if (now < start) state = 'upcoming';
            else state = 'past';
          }
          slide.querySelector('.sweepstakes-prizes__card')?.setAttribute('data-state', state);
          const badge = slide.querySelector('.sweepstakes-prizes__badge');
          if (badge) {
            badge.dataset.state = state;
            this.applyBadgeText(badge, state);
          }
          return { slide, start, end, state };
        });

        const active = decorated.filter((s) => s.state === 'active');
        const upcoming = decorated
          .filter((s) => s.state === 'upcoming')
          .sort((a, b) => a.start - b.start);
        const past = decorated
          .filter((s) => s.state === 'past')
          .sort((a, b) => b.end - a.end);
        const undated = decorated.filter((s) => s.state === 'undated');

        let ordered;
        if (active.length > 0) {
          ordered = [...active, ...upcoming, ...past, ...undated];
        } else {
          this.prependEmptyState();
          ordered = [...upcoming, ...past, ...undated];
        }

        this.wrapper.replaceChildren(
          ...(this.emptyStateSlide ? [this.emptyStateSlide] : []),
          ...ordered.map((d) => d.slide)
        );
      }

      prependEmptyState() {
        const slide = document.createElement('div');
        slide.className = 'sweepstakes-prizes__slide swiper-slide';
        slide.innerHTML = `<div class="sweepstakes-prizes__empty">${this.emptyText}</div>`;
        this.emptyStateSlide = slide;
      }

      countdownText(targetMs) {
        const diff = targetMs - Date.now();
        if (diff <= 0) return 'Starting soon';
        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        if (days >= 1) return `Unlocks in ${days}d ${hours}h`;
        if (hours >= 1) return `Unlocks in ${hours}h ${minutes}m`;
        return `Unlocks in ${minutes}m`;
      }

      applyBadgeText(badge, state) {
        let text = '';
        if (state === 'upcoming') {
          const target = this.parseDate(badge.dataset.countdownTo);
          if (target !== null) text = this.countdownText(target);
        } else if (state === 'active') {
          text = (badge.dataset.activeText || '').trim();
        } else if (state === 'past') {
          text = (badge.dataset.pastText || '').trim();
        }
        if (text) {
          badge.textContent = text;
          badge.hidden = false;
        } else {
          badge.textContent = '';
          badge.hidden = true;
        }
      }

      startBadgeUpdates() {
        const tick = () => {
          this.querySelectorAll('.sweepstakes-prizes__badge[data-state="upcoming"]').forEach((badge) => {
            const target = this.parseDate(badge.dataset.countdownTo);
            if (target !== null) badge.textContent = this.countdownText(target);
          });
        };
        this.countdownInterval = setInterval(tick, 60000);
      }

      initSlider() {
        if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

        const slidesPerViewMobile = parseFloat(this.dataset.slidesMobile || '1.1');
        const slidesPerViewDesktop = parseFloat(this.dataset.slidesDesktop || '1.5');

        const options = {
          slidesPerView: slidesPerViewMobile,
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: slidesPerViewDesktop,
              spaceBetween: 16,
            },
          },
          navigation: {
            nextEl: this.querySelector('.sweepstakes-prizes__next'),
            prevEl: this.querySelector('.sweepstakes-prizes__prev'),
          },
          threshold: 4,
          grabCursor: true,
          allowTouchMove: true,
          watchOverflow: true,
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.swiperEl, options);
        this.sliderInstance.init();
      }
    }
  );
}
